import React, {Component} from 'react';

import {Projects} from '../common/vars';

import PortfolioProject from '../elements/PortfolioProject';

import '../../styles/components/projectList.css';

class ProjectList extends Component {
    render() {
        return (
            <div className="project-list">
            {Projects.map((project, i) => {
                return (<PortfolioProject project={project} data-id={i} key={'ppl' + i}></PortfolioProject>)
            })}
            </div>
        )
    }
}

export default ProjectList;



// WEBPACK FOOTER //
// ./src/js/components/ProjectList.js